// Avtalstexterna i docs/avtal, inbyggda i kontot (ADR 0100). Versionerna
// kommer från @leadledger/domain, och ett test kontrollerar att de stämmer.
import { AGREEMENTS, type AgreementKind } from '@leadledger/domain';
import villkor from '../../../../../docs/avtal/allmanna-villkor.md?raw';
import bitradesavtal from '../../../../../docs/avtal/bitradesavtal.md?raw';

export const AVTALSTEXT: Record<AgreementKind, string> = { terms: villkor, dpa: bitradesavtal };

export { AGREEMENTS };
